<template>
  <div id="navBar">
  <div class="navbar">
      <ul class="nav navbar-nav">
         <li class="item">
          <img class="logoImg" src="/static/images/common/m_logo.png" alt="">
        </li>
        <li @click="menuBtn">
          <div class="menuBox"></div>
        </li>
        <!-- <li>
          <span>{{$t("content1_txt.con_tit")}}</span>
        </li> -->

      </ul>

      <ul class="menuList">
        <label v-for="(item,index) in menuList" :key="item.name">
        <router-link :to="{path:'/'+item.link}" v-if="index!=1">
          <li :class="linkName ==item.link?'active':''">
          <span>{{$t(item.name)}}</span>
          </li>
        </router-link>
        <li :class="linkName ==item.link?'active':''" @click='menuClick' v-if="index==1">
          <span>{{$t(item.name)}}<img src="/static/images/common/ic_more.png" alt=""></span>
          <ul class="secondMenu" v-show="menuShow">
            <router-link :to="{path:'/mSoftware'}">
            <li :class="links==1?'active':''">Cashier POS</li>
            </router-link>
            <router-link :to="{path:'/mHardware'}">
            <li :class="links==2?'active':''">Backstage</li>
            </router-link>
          </ul>
        </li>
        </label>
        <li class="item languageBtn" >
          <span><span @click="changeLang(item.name)" :class="item.name == language?'langSelect':''" v-for="(item,index) in languageList" :key="index"> {{item.text}} </span></span>
        </li>
      </ul>
    </div>
    <!-- <transition name="fade">
      <div class="navMenu active" v-show="menuShow" @mouseleave="menuHiddens()">
        <div class="con">
          <router-link :to="{path:'/Software'}">
            <div class="left">
              <div class="menuImg"><img src="/static/images/common/ic_app.png" alt=""></div>
              <div>
                <div class="title">{{$t("header.tit1")}}</div>
                <div class="titleSub">
                  <ul>
                    <li>{{$t("header.titSub1.text1")}}</li>
                    <li>{{$t("header.titSub1.text2")}}</li>
                    <li>{{$t("header.titSub1.text3")}}</li>
                    <li>{{$t("header.titSub1.text4")}}</li>
                  </ul>
                </div>
              </div>
            </div>
          </router-link>
           <router-link :to="{path:'/Hardware'}">
            <div class="right">
              <div class="menuImg"><img src="/static/images/common/ic_web.png" alt=""></div>
              <div>
                <div class="title">{{$t("header.tit2")}}</div>
                <div class="titleSub">
                  <ul>
                    <li>{{$t("header.titSub2.text1")}}</li>
                    <li>{{$t("header.titSub2.text2")}}</li>
                    <li>{{$t("header.titSub2.text3")}}</li>
                    <li>{{$t("header.titSub2.text4")}}</li>
                  </ul>
                </div>
              </div>
            </div>
           </router-link>
        </div>
      </div>
    </transition> -->
    <div class="mask" @click='maskBtn'>

    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: 'app-header',
  data() {
    return {
      menuShow:false,
      menuList:[
        {
          name:"menu.Home",
          link:'mHome'
        },
        {
          name:"menu.Features",
          link:'mFeatures'
        },
        // {
        //   name:"menu.Products",
        //   link:'mProducts'
        // },
        {
          name:"menu.FAQ",
          link:'mFAQ'
        },
        // {
        //   name:"menu.Blog",
        //   link:'mBlog'
        // },
        {
          name:"menu.Contact",
          link:'mContact'
        },
        {
          name:"menu.About",
          link:'mAbout'
        },
      ],
      linkName:'',
      links:0,
      lang_en:false,
      languageList:[
        {
          name:'ZH',
          text:'中文 /'
        },
        // {
        //   name:'EN',
        //   text:' English /'
        // },
        {
          name:'PH',
          text:' Philippines /'
        },
        {
          name:'MA',
          text:' Malayisa'
        }
      ],
      language:'PH'
    };
  },
  //定义这个sweiper对象
  computed: {

  },
  mounted() {
    this.url_change()
    this.language = this.$getCookie('langs')
  },
  methods: {
    menuClick(){
      if(this.menuShow){
        this.menuShow = false
      }else{
        this.menuShow = true
      }
    },
    menuBtn(){
      document.querySelector('body').setAttribute('class', 'open-nav')
    },
    maskBtn(){
        document.querySelector('body').removeAttribute('class')
    },
    changeLang(el) {
      this.language= el
      this.$i18n.locale = el
      this.$setCookie('langs',el);
      document.querySelector('body').removeAttribute('class')
    },
     url_change () {
        let that = this, url = window.location.href.split('/')[3].split('?')
        let link =''
        if(url[0]=='mSoftware'||url[0]=='mHardware'){
          link = 'mFeatures'
          if(url[0]=='mSoftware'){
            that.links = 1
          }else if(url[0]=='mHardware'){
            that.links = 2
          }
        }else{
          that.links = 0
          link = url[0]
        }
        that.linkName = link
      }
  },
  watch: {      // 监听路由变化
    $route (to, from) {
      this.url_change()
      this.menuShow = false
      document.querySelector('body').removeAttribute('class')
    }
  }
};
</script>
<style scoped lang="less" type="text/less">
#navBar{
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-in;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .navbar{
    height: 50px;
    line-height: 50px;
    background: #fff;
    width: 100%;
    text-align: center;
    box-shadow:0px 3px 10px rgba(0,0,0,0.08);
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 100;
    .nav{
      // width: 80%;
      // min-width: 960px;
      margin: 0 auto;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      position: relative;
      .item{
        text-align: left;
        .logoImg{
          width: 50%;
        }
      }
      .menuBox{
        display: inline-block;
        position: relative;
        height: 2px;
        width: 24px;
        background: #707070;
        top:-5px;
        &::before{
          content:'';
          display: inline-block;
          height: 2px;
          width: 24px;
          background: #707070;
          position:absolute;
          top: -7px;
          left: 0;
        }
        &::after{
          content:'';
          display: inline-block;
          height: 2px;
          width: 24px;
          background: #707070;
          position:absolute;
          bottom: -7px;
          left: 0;
        }
        // &.open{
        //   height: 0px;
        //   &::before{
        //   content:'';
        //   display: inline-block;
        //   height: 2px;
        //   width: 30px;
        //   background: #707070;
        //   position:absolute;
        //   top: -8px;
        //   left: 0;
        //   transform:rotate(45deg);
        // }
        // &::after{
        //   content:'';
        //   display: inline-block;
        //   height: 2px;
        //   width: 30px;
        //   background: #707070;
        //   position:absolute;
        //   bottom: 6px;
        //   left: 0;
        //   transform:rotate(-45deg);
        // }
        // }
      }
      li{
        display: inline-block;
        padding: 0 15px;
        color: #666;
        &:hover{
          cursor: pointer;
        }
        &.active{
          color: #333;
          font-weight: bold;
        }
        &.languageBtn{
          padding-left: 80px;
          font-size: 14px;
          position: absolute;
          right: 60px;
          .langSelect{
            font-weight: bold;
            color: #333;
          }
        }
        span{
          position: relative;
          top: 3px;
        }
      }
    }
    .menuList{
      background: #fff;
      position: fixed;
      width: 300px;
      right:-300px;
      top: 0;
      color: #333;
      padding: 15px 0;
      line-height: 5rem;
      font-size: 1.8rem;
      a{
        color: #333;
      }
      li{
        padding-left: 40px;
        text-align: left;
        color: #666;
        &:hover{
          cursor: pointer;
        }
        &.active{
          color: #333;
          font-weight: bold;
        }
        &.languageBtn{
          font-size: 1.4rem;
          line-height: 2.4rem;
          margin-top: 2rem;
          .langSelect{
            font-weight: bold;
            color: #333;
          }
        }
        span{
          position: relative;
          top: 3px;
        }
        .secondMenu{
          li{
            font-weight: 400;
            padding-left: 20px;
            line-height: 3.4rem;
            font-size: 1.4rem;
            &.active{
              color: #333;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .navMenu{
    position:fixed;
    width: 100%;
    left: 0;
    z-index: 8;
    background: #fff;
    padding: 36px 0;
    box-shadow:0px 3px 10px rgba(0,0,0,0.08);
    .con{
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      .left,.right{
        display: flex;
        justify-content: center;
        align-items: center;
        .menuImg{
          margin-right: 30px;
        }
        .title{
          color: #333;
          font-size: 20px;
          font-weight: bold;
          position: relative;
          left: -16px;
        }
        .titleSub{
          padding-top: 10px;
          ul li{
            color: #999;
            font-size: 12px;
            line-height: 24px;
            list-style: disc;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/common/header.vue